import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ children }) {
    const { user, loading, isAdmin } = useAuth();

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    if (!isAdmin()) {
        return (
            <div className="loading-container" style={{ flexDirection: 'column', gap: '12px' }}>
                <p style={{ color: '#e53e3e', fontWeight: 600, fontSize: '1.1rem' }}>
                    Access Denied
                </p>
                <p style={{ color: '#555' }}>
                    You do not have permission to view this page. Please log in as an admin.
                </p>
            </div>
        );
    }

    return children;
}

export function PublicRoute({ children }) {
    const { user, loading, isAdmin } = useAuth();

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    return (user && isAdmin()) ? <Navigate to="/sync-dashboard" /> : children;
}
